import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSpinComponent } from 'ng-zorro-antd/spin';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { IcdCodeType } from '../../../../core/api/mhsConfigurationApiClient';
import { CodesService } from '../../services/codes-service';

@Component({
  selector: 'app-icd-code-details',
  imports: [RouterLink, NzButtonModule, NzCardModule, NzIconModule, NzSpinComponent, NzTagModule],
  templateUrl: './icd-code-details.html',
  styleUrl: './icd-code-details.scss',
})
export class IcdCodeDetailsComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly codesService = inject(CodesService);

  readonly type = this.route.snapshot.data['codeType'] as IcdCodeType;
  readonly title = this.type.replace('Icd', 'ICD-');
  readonly code = this.route.snapshot.paramMap.get('code') ?? '';
  readonly details = toSignal(this.codesService.get(this.type, this.code), { initialValue: null });
  readonly listUrl = ['/codes', this.type.toLowerCase()];
  readonly verificationStatus = computed(() =>
    this.details()?.isVerified ? 'Zweryfikowany' : 'Niezweryfikowany',
  );
  readonly metaSections = computed(() =>
    Object.entries(this.details()?.meta ?? {})
      .filter(([, items]) => items?.length)
      .map(([key, items]) => ({ key, label: this.metaLabel(key), items })),
  );

  metaLabel(key: string): string {
    const labels: Record<string, string> = {
      settlements: 'Dodatkowe kryterium NFZ',
    };

    return labels[key] ?? key;
  }
}
